import React from 'react';
import { LayoutProps } from '../types';
import SeoHead from './SeoHead';

const Layout: React.FC<LayoutProps> = ({
  children,
  title = 'AKAS Blog',
  description = 'AKAS cloud-based business ERP solutions in Cambodia',
  keywords,
  canonicalPath,
  image,
  noIndex,
  ogType = 'website',
}) => {
  const path = canonicalPath ?? '/blog';

  return (
    <>
      <SeoHead
        title={title}
        description={description}
        keywords={keywords}
        path={path}
        image={image}
        noIndex={noIndex}
        type={ogType}
      />
      {children}
    </>
  );
};

export default Layout;
